import * as yup from "yup";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efa018Codigo: yup.string().required(translate("Código é requerido")),
	efa018Descricao: yup.string().required(translate("Descrição é requerido")),
	efa018Ativo: yup.boolean(),
	efa018Templateconfig: yup.string(),
	eftba019:  yup.array().of(yup.object().shape({
		efa019Id: yup.number(),
		efa019Nome: yup.string().required(translate("Nome é requerido")),
		efa019Descricao: yup.string().required(translate("Descrição é requerido"))
	}))
});

export default  addAndChangeSchema;
